import { EventEmitter } from '@angular/core';
import { Component, Input, OnInit, Output } from '@angular/core';
import { AttributeDefinitionValueListItem } from '../../models/attributes/attributeDefinitionValueListItem';
import { AccessibilityService } from '../../services/accessibility.service';

@Component({
  selector: 'skill',
  templateUrl: './skill.component.html',
  styleUrls: ['./skill.component.scss'],
})
export class SkillComponent implements OnInit {
  @Input() skillLevels: AttributeDefinitionValueListItem[] = [];
  @Input() editMode = false;
  @Input() selectedSkillLevel: AttributeDefinitionValueListItem;
  @Input() required = false;
  @Input() isTouched = false;
  @Input() errorMessage;
  @Input() ariaLabelledby: string;
  @Input() title: string;

  @Output() selectedChanged = new EventEmitter<AttributeDefinitionValueListItem>();
  hoveredSkillLevel: AttributeDefinitionValueListItem;
  constructor(private accessibilityService: AccessibilityService) {}

  ngOnInit(): void {}

  get hasError(): boolean {
    return this.required && this.isTouched && !this.selectedSkillLevel;
  }

  onMouseHover(skillLevel: AttributeDefinitionValueListItem) {
    this.hoveredSkillLevel = skillLevel;
  }

  onMouseLeave() {
    this.hoveredSkillLevel = null;
  }
  keyDown(event: KeyboardEvent, i: number) {
    const allowKeyboardEventCodes = ['ArrowRight', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'Space'];

    if (allowKeyboardEventCodes.includes(event.code)) {
      event.preventDefault();
      let skillLevel = this.skillLevels[i];

      if (event.code == 'ArrowRight' || event.code == 'ArrowUp') {
        skillLevel = this.skillLevels[i + 1];
      }

      if (event.code == 'ArrowLeft' || event.code == 'ArrowDown') {
        skillLevel = this.skillLevels[i - 1];
      }

      if (skillLevel == null) return;

      let siblingElement = document.getElementById(`${skillLevel.id}`);
      if (siblingElement == null) return;
      siblingElement.focus();
      this.onClick(skillLevel);
    }
  }
  onClick(skillLevel: AttributeDefinitionValueListItem) {
    this.selectedSkillLevel = skillLevel;
    this.selectedChanged.emit(skillLevel);

    //only for using in screen ready
    let screenReaderAction = this.getValue(skillLevel) + ' selected';
    this.accessibilityService.talk(screenReaderAction);
  }

  getValue(skillLevel: AttributeDefinitionValueListItem) {
    return skillLevel.itemDescription ? skillLevel.itemDescription : skillLevel.itemValue;
  }

  getTooltipValue(skillLevel: AttributeDefinitionValueListItem) {
    let desc = skillLevel.itemDescription ? ` (${skillLevel.itemDescription})` : '';
    return `${skillLevel.rank}. ${skillLevel.itemValue}${desc}`;
  }
  onDeleteSkill() {
    this.selectedSkillLevel = null;
    this.selectedChanged.emit(null);

    //only for screen reader use
    this.accessibilityService.talk(this.title + ' value deleted');
  }
}
